import {useParams} from 'react-router-dom';
import {FC, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { authActions } from './actions/AuthAction'
import { RootState } from './Store'

export const AccessTokenLogin : FC = () => {
    const { accessToken } = useParams();
    const dispatch = useDispatch();
    const loginError = useSelector((state: RootState): boolean => state.authState.isLoginError);
    
    useEffect(() => {
        if (!accessToken) return;
        dispatch(authActions.login({permaToken: accessToken}))
    }, [accessToken])

    return(<label>{loginError ? "Fejl i login" : "Logger ind"}</label>)
}